export const rootPath = '/';
export const overviewPath = '/overview';
export const inspectioPath = '/inspectio';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/routes.ts